import React from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import Problem from './components/Problem';
import Products from './components/Products';
import Story from './components/Story';
import Benefits from './components/Benefits';
import Testimonials from './components/Testimonials';
import Included from './components/Included';
import CTA from './components/CTA';
import FAQ from './components/FAQ';
import Footer from './components/Footer';
import MetaPixel from './components/MetaPixel';
import FloatingCTA from './components/FloatingCTA';
import PurchaseNotification from './components/PurchaseNotification';
export function App() {
  return <div className="w-full min-h-screen bg-[#FDF8F3]" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <Header data-id="element-2" />
      <main className="w-full" data-id="element-3">
        <Hero data-id="element-4" />
        <Problem data-id="element-5" />
        <Products data-id="element-6" />
        <Story data-id="element-7" />
        <Benefits data-id="element-8" />
        <Testimonials data-id="element-9" />
        <Included data-id="element-10" />
        <CTA data-id="element-11" />
        <FAQ data-id="element-12" />
      </main>
      <Footer data-id="element-13" />
      <FloatingCTA data-id="element-14" />
      <PurchaseNotification data-id="element-15" />
    </div>;
}